export const formSchema = (config) => {
  const baseFormSchema = config.blocks.blocksConfig.form.formSchema;
  return (data) => {
    const baseSchema = baseFormSchema(data);
    return {
      ...baseSchema,
      fieldsets: [
        {
          ...baseSchema.fieldsets.find((fs) => fs.id === 'default'),
          fields: [
            ...baseSchema.fieldsets.find((fs) => fs.id === 'default').fields,
            'endpoint',
          ],
        },
        ...baseSchema.fieldsets.filter((fs) => fs.id !== 'default'),
      ],
      properties: {
        ...baseSchema.properties,
        endpoint: {
          title: 'Endpoint',
          choices: [
            ['standard', 'Standard'],
            ['profesionals', 'Profesionals'],
            ['locations', 'Locations'],
            ['contact', 'Contact'],
            ['subscribe', 'Subscribe'],
          ],
        },
      },
    };
  };
};
